// extracted by mini-css-extract-plugin
module.exports = {"themeCover":"ThemeCover_themeCover__kBoKL"};